module.exports = __webpack_public_path__ + "media/store/images/arrow-v2-left-7baf7656123d35199fe6a34f099a882b.svg";